import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { Box, Button, useTheme } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { dispatchNotificationEvent } from "../../NotificationSystem";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import EditIcon from "@mui/icons-material/Edit";
import { EditCodeComponent } from "./EditCodeComponent";
import { PrismLight as SyntaxHighlighter } from "react-syntax-highlighter";
import python from "react-syntax-highlighter/dist/esm/languages/prism/python";
import prism from "react-syntax-highlighter/dist/esm/styles/prism/okaidia";
SyntaxHighlighter.registerLanguage("python", python);
export function LLMPythonCode({ codeString, language, disabled, codeProps, handleEditCode, }) {
    const [editMode, setEditMode] = useState(false);
    const acceptEditedCode = (editedCode) => {
        setEditMode(false);
        handleEditCode(editedCode);
    };
    return editMode ? (_jsx(EditCodeComponent, { codeString: codeString, disabled: disabled, acceptEditedCode: acceptEditedCode, cancelEditMode: () => {
            setEditMode(false);
        } })) : (_jsx(SyntaxHighlighter, Object.assign({ children: codeString, style: prism, language: language, PreTag: "div", wrapLines: true, CodeTag: (props) => (_jsx(PythonCodeComponent, Object.assign({ codeString: codeString, disabled: disabled, activateEditMode: () => {
                setEditMode(true);
            } }, { children: props.children }))) }, codeProps)));
}
export function PythonCodeComponent({ children, codeString, disabled, activateEditMode, }) {
    const copyCode = () => {
        navigator.clipboard.writeText(codeString);
    };
    const runCode = () => {
        // @ts-ignore
        const term = window.term;
        if (!term) {
            dispatchNotificationEvent({
                message: "The console is not available.",
                type: "error",
            });
            return;
        }
        const lines = codeString.split("\n");
        lines.forEach((line) => term.exec(line));
        term.exec("");
        term.history().append(codeString);
    };
    return (_jsxs(Box
    //   component="span"
    , Object.assign({ 
        //   component="span"
        sx: {
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            display: "flex",
            gap: 2,
        } }, { children: [_jsx(Box, { children: children }), _jsx(CodeBlockButton, { copyCode: copyCode, runCode: runCode, editCode: activateEditMode, disabled: disabled })] })));
}
function CodeBlockButton({ copyCode, runCode, editCode, disabled, }) {
    const theme = useTheme();
    // const btnColor = theme.palette.primary.light;
    const [justCopied, setJustCopied] = useState(false);
    const handleClickCopy = () => {
        copyCode();
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), 1000);
    };
    return (_jsxs(Box, Object.assign({ sx: { display: "flex" } }, { children: [_jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Copy", onClick: handleClickCopy, baseColor: "#ffffff", disabled: disabled }, { children: justCopied ? (_jsx(CheckIcon, { fontSize: "small" })) : (_jsx(ContentCopyIcon, { sx: { fontSize: "1rem" } })) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Edit", onClick: editCode, baseColor: "#ffffff", disabled: disabled }, { children: _jsx(EditIcon, { sx: { fontSize: "1rem" } }) })), _jsx(Button, Object.assign({ size: "small", disabled: disabled, variant: "contained", endIcon: _jsx(KeyboardReturnIcon, { fontSize: "small" }), color: "info", onClick: runCode, sx: {
                    p: 0,
                    ml: 1,
                    textTransform: "none",
                    // color: btnColor,
                    // borderColor: btnColor,
                    // "&:hover": {
                    //   borderColor: lighten(btnColor, 0.5),
                    //   color: lighten(btnColor, 0.5),
                    // },
                    "&.Mui-disabled": {
                        opacity: 0.3,
                        color: "white",
                        backgroundColor: theme.palette.primary.main,
                    },
                } }, { children: "Run" }))] })));
}
